var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('van-cell-group',{attrs:{"title":_vm.formInfo.Name}},[_c('div',{staticClass:"form"},[(_vm.formKey && _vm.formConf)?_c('Parser',{attrs:{"formConf":_vm.formConf},on:{"submit":_vm.submit}}):_vm._e()],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }